<template lang="pug">
multiselect(
    track-by="id"
    label="name"
    :options="data"
    :internal-search="false"
    :value="value"
    @search-change="loadProducts"
    :loading="onLoading('fetch-products')"
    @select="onSelect"
    :placeholder="placeholder"
    :disabled="disabled"
)
    template(slot="option", slot-scope="props")
        .clear
            span.clear {{ props.option.name }}
            small.clear.text-muted {{ props.option.code }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import inventoryProduct from '@js/store/modules/inventory-product';

export default {
    props: {
        placeholder: {
            type: String,
            default: '',
        },

        value: {
            type: Object,
            default: () => null,
        },

        outletId: {
            type: Number,
            default: null,
        },

        supplierId: {
            type: Number,
            default: null,
        },

        type: {
            type: String,
            default: null,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            exclude_product_ids: [],
            data: [],
        };
    },

    computed: {
        ...mapGetters('inventoryProduct', ['productList']),
    },

    watch: {
        productList() {
            this.data = this.productList.filter(
                product => !this.exclude_product_ids.includes(product.id),
            );
        },
    },

    beforeCreate() {
        if (!this.$store.hasModule('inventoryProduct')) {
            this.$store.registerModule('inventoryProduct', inventoryProduct);
        }
    },

    mounted() {
        this.loadProducts();

        this.$on('product-list-reload', () => {
            this.loadProducts();
        });
    },

    methods: {
        ...mapActions('inventoryProduct', [
            'getProductList',
            'emptyProductList',
        ]),

        onSelect(product) {
            this.$emit('select', product);
            this.$emit('input', product);

            this.exclude_product_ids.push(product.id);
            this.data = this.productList.filter(
                product => !this.exclude_product_ids.includes(product.id),
            );
        },

        loadProducts: _.debounce(function(query = '') {
            const params = {
                query,
                outlet_id: this.outletId,
                type: this.type,
                supplier_id: this.supplierId,
            };

            this.getProductList(params);
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/selector/inventory-product-selector.vue